// =========================
// Officers Information
// =========================

// Array of officer objects with relevant details
const officers = [
  {
    id: 1,
    title: 'President',
    name: 'Taylor Heatherly',
    image: require('./images/officers/taylor.jpeg'), // Load image from local folder
    description: [
      'Year - Senior',
      'Major - Political Science',
      'Hometown - Honolulu',
      'Favorite Hui Memory - Amazing Race and Lū\'au',
      'Fun Fact - "I recently finished wastching the Hunger Games Series"',
    ],
  },
  {
    id: 2,
    title: 'Vice President',
    name: 'Bruin Yomono',
    image: require('./images/officers/bruin.jpeg'),
    description: [
      'Year - Senior',
      'Major - Mechanical Engineering',
      'Hometown - Hilo',
      'Favorite Hui Memory - Eating Lū\'au 2025 food',
      'Fun Fact - "I can eat a Costco hotdog in 2 bites"',
    ],
  },
  {
    id: 3,
    title: 'Secretary',
    name: 'Jaycie Matsunami',
    image: require('./images/officers/jaycie.jpeg'),
    description: [
      'Year - Senior',
      'Major - Community, Environment, and Planning',
      'Hometown - Aiea',
      'Favorite Hui Memory - Spring Retreat and Canada',
      'Fun Fact - "I was born on Friday the 13th"',
    ],
  },
  {
    id: 4,
    title: 'Event Coordinator',
    name: 'Macey Kim',
    image: require('./images/officers/macey.jpeg'),
    description: [
      'Year - Sophmore',
      'Major - Buisness Communications',
      'Hometown - Mililani',
      'Favorite Hui Memory - Spring retreat',
      'Fun Fact - "I studied abroad in Japan"',
    ],
  },
  {
    id: 5,
    title: 'Event Coordinator',
    name: 'Tiffany Matsushima',
    image: require('./images/officers/tiffany.JPEG'),
    description: [
      'Year - Junior',
      'Major - Electrical Engineering',
      'Hometown - Mililani',
      'Favorite Hui Memory - Playing Intramurals with HUI',
      'Fun Fact - "I got to Shabuya every week"',
    ],
  },
  {
    id: 6,
    title: 'Event Coordinator',
    name: 'Felicity Nagel',
    image: require('./images/officers/felicity.jpg'),
    description: [
      'Year - Sophmore',
      'Major - Environmental Science',
      'Hometown - Kailua',
      'Favorite Hui Memory - Spring Retreat 2025',
      'Hobbies - "I used to train to fly small planes and I have flown inter-island all alone before"',
    ],
  },
  {
    id: 7,
    title: 'Treasurer',
    name: 'Landon Chun',
    image: require('./images/officers/landon.JPEG'),
    description: [
      'Year - Junior',
      'Major - Finance and Accounting',
      'Hometown - Salt Lake',
      'Favorite Hui Memory - Freshman year Canada trip',
      'Fun Fact - "I enjoy surfing, golfing, and snowboarding in my free time"',
    ],
  },
  {
    id: 8,
    title: 'Community Outreach',
    name: 'Lauren Shaw',
    image: require('./images/officers/lauren.JPEG'),
    description: [
      'Year - Senior',
      'Major - Biology: Physiology (premed)',
      'Hometown - Moanalua',
      'Favorite Hui Memory - Freshman year Canada trip',
      'Fun Fact - "I had 7 widsom teeth"',
    ],
  },
  {
    id: 9,
    title: 'Historian',
    name: 'Demi Clark',
    image: require('./images/officers/demi.jpeg'),
    description: [
      'Year - Junior',
      'Major - Medical Anthropology and Global Health along with Journalism',
      'Hometown - Pearl City',
      'Favorite Hui Memory - Lū\'au 2025 and Flag Football',
      'Fun Fact - "I can tie my shoelaces in under 2 seconds"',
    ],
  },
  {
    id: 10,
    title: 'Cultural Chair',
    name: 'Jason Cheers',
    image: require('./images/officers/jason.JPEG'),
    description: [
      'Year - Sophomore',
      'Major - Biology',
      'Hometown - Āliamanu',
      'Favorite Hui Memory - Spring Retreat 2025 and Lū\'au 2025',
      'Fun Fact - "I really like all kinds of food"',
    ],
  },
  {
    id: 11,
    title: 'Cultural Chair',
    name: 'Gael Chun-Rivas',
    image: require('./images/officers/gael.JPEG'),
    description: [
      'Year - Sophmore',
      'Major - Electrical and Computer Engineering',
      'Hometown - Hawaii Kai',
      'Favorite Hui Memory - Spring Retreat 2025',
      'Fun Fact - "I have a twin sister"',
    ],
  },
  {
    id: 12,
    title: 'Webmaster',
    name: 'Matthew Chee',
    image: require('./images/officers/matthew.jpg'),
    description: [
      'Year - Junior',
      'Major - Electrical and Computer Engineering',
      'Hometown - Hawaii Kai',
      'Favorite Hui Memory - Freshman year Canada trip',
      'Fun Fact - "I am allergic to peanuts"',
    ],
  },
];

// =========================
// FAQ Section
// =========================

// List of common questions and answers
const faq = [
  {
    question: "Who can participate in Hui?",
    answer: "We're open to anyone regardless if you're from Hawai'i or have ties to Hawai'i!",
  },
  {
    question: "How do I get involved?",
    answer: "Be sure to sign up for our Mailchimp mailing list, Slack, and follow us on Instagram. Links are in the website footer.",
  },
  {
    question: "What does time commitment look like?",
    answer: "There are no required events, so come out to whichever events interest you. Keep in mind that a few of our events have capacity limits",
  },
  {
    question: "What are dues?",
    answer: "Dues are $13 per quarter or $30 for the year.",
  },
  {
    question: "What types of events do you host?",
    answer: "We host a variety of events including monthly general meetings, attending Mariners games, ice skating, and UW football potlucks. Our largest events are the winter quarter Canada trip, spring retreat, and our annual lu'au at the end of the year in May.",
  },
  {
    question: "Can I participate in events as a non-member?",
    answer: "Of course! Just keep in mind that some paid events will cost more for non-members, so we highly recommend paying dues.",
  },
  {
    question: "How can I as a student get involved with Lu'au?",
    answer: `Please reach out to our logistics chair, Kayla Chun, over <a href="https://huihoalohaulana.slack.com/join/shared_invite/zt-whuf2ioj-q3rYxaDqbaji2NoDtKZjGg#/shared-invite/email" target="_blank" rel="noopener noreferrer">Slack</a> to get involved with a committee. If you would like free admission to Lu'au, you need to participate in at least two committees (country store, dance, decoration, food, publicity, or ticketing).`,
  },
  {
    question: "How can I as a parent or sponsor get involved with Lu'au?",
    answer: 'Please reach out to our Lu\'au committee at <a href="mailto:hui@uw.edu">hui@uw.edu</a> for information on how to get involved!',
  },
];

// =========================
// Advice Section
// =========================

// List of common questions and answers
const advice= [
  {
    question: "What are some of Hui's favorite spots on campus",
    answer: "- Suzzallo Starbucks <br>- The Quad <br>- By the water, right below the Fishery Sciences Building <br>- The Cut <br>- The Law Library (you can get access by taking LAW 100) <br>- Odegaard Library <br>- IMA <br>- Denny Field <br>- Allen Library <br>- Henry Art Gallery",
  },
  {
    question: "What are your favorite things to do in Seattle?",
    answer: "- Exploring farmers markets <br>- Trying new places to eat <br>- Watching Mariners games <br>- Going on hikes with friends <br>- Walking on the Burke Trail <br>- Thrifting <br>- Visit other parts of Seattle (especially Westlake and Capitol Hill) <br>- Exploring the city using the link or taking the bus (having the husky card makes getting around easy)",
  },
  {
    question: "What is your favorite Hui memory",
    answer: "- Hui Amazing Race <br>- Annual Canada Trip <br>- Spring Retreat <br>- Intramurals",
  },
  {
    question: "What is one piece of advice you have for the incoming class?",
    answer: "- Learn how to enjoy time by yourself because sometimes you'll need it, especially as your social life grows <br>- Explore new interests, hobbies, and people but most importantly, remember to have fun and find happiness in everything that you do<br> - Try new things and don't be afraid to make mistakes <br>- Don't skip class <br>- Enjoy yourself! <br>- You do not need to have everything figured out at 18 <br>- It's easy to get overwhelmed and feel lost or like you're falling behind. Don't be ashamed to switch your plan entirely or take a beat to sit and consider a different option <br>- Come to Hawaii club events! Seriously, having this community really shaped my freshman year and I've made so many amazing friends <br>- Take advantage of the free public transportation system that UW offers <br>- Don't be afraid to step out of your comfort zone and be open minded <br>- Use your GenEd credits to learn about fun topics that you wouldn't otherwise learn in your major",
  },

  {
    question: "What are some must-pack items?",
    answer: "- Water repellent/resistant shoes, a good-quality rain jacket, a puffer jacket, or clothes you can layer <br>- Don't forget your electronic chargers and cords! These are little things that we need every day but having to repurchase in Seattle can be annoying and unnecessary extra costs <br>- Comfy shoes to walk in and blue light glasses <br>- Mattress toppers and ear plugs (if you are a light sleeper) <br>- Your favorite snacks from home",
  },

];

// =========================
// Events Calendar
// =========================

// List of upcoming club events
const events = [
  {
    title: '2nd Mixer',
    date: '2025-11-05',
    extendedProps: {
      location: 'SAV 155',
      description: 'Mingling! Engage in fun conversations with bigs/littles with different question prompts and activities!',
      time: '5:00 PM – 7:00 PM',
    },
  },
  {
    title: 'Club Meeting',
    date: '2025-11-08',
    extendedProps: {
      location: 'HUB 214',
      description: 'Club updates & snacks!',
      time: '12:00 PM – 1:00 PM',
    },
  },
];

// =========================
// Intramurals Schedule
// =========================

// List of intramural games (can be different from events)
const intramurals = [
  {
    title: '', // Optional: You may want to give this game a name
    date: '2025-06-19',
    extendedProps: {
      location: 'HUB 145',
      description: 'Bring your own flowers and string!',
      time: '2:00 PM – 4:00 PM',
      link: 'https://example.com/lei-workshop',
    },
  },
  {
    title: 'Game 2',
    date: '2025-06-30',
    extendedProps: {
      location: 'HUB 145',
      description: 'Club updates & snacks!',
      time: '5:30 PM – 6:30 PM',
      link: 'https://example.com/join-meeting',
    },
  },
  {
    title: 'Game 3',
    date: '2025-06-01',
    extendedProps: {
      location: 'HUB 145',
      description: 'Traditional dishes served at HUB 145.',
      time: '6:00 PM – 8:00 PM',
      link: '',
    },
  },
];

// =========================
// Hall of Fame
// =========================

// Displays champion teams by year
const halloffame = [
  { name: 'Football 2024', image: require('./images/football2024.jpg') },
  { name: 'Soccer 2024', image: require('./images/soccer2024.jpg') },
  { name: 'Volleyball 2024', image: require('./images/volleyball2024.jpg') },
  { name: 'Futsal 2023', image: require('./images/futsal2023.jpg') },
  { name: 'Softball 2022', image: require('./images/softball2022.jpg') },
];

// =========================
// Exporting all data
// =========================

export {
  advice,
  faq,
  officers,
  events,
  intramurals,
  halloffame,
};
